module.exports = __webpack_public_path__ + "45ce17a9302eff24f918710799cce7ee.png";